// extracted by mini-css-extract-plugin
export default {"menu":"MainNav_menu__rxetV","list":"MainNav_list__5TKO2","item":"MainNav_item__iS+tz","link":"MainNav_link__7cOZG"};